import React from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import AboutSection from "../components/AboutSection";
import WhoWeAre from "../components/WhoWeAre";
import ExpertiseSection from "../components/ExpertiseSection";
import BenefitsSection from "../components/BenefitsSection";
import FAQ from "../components/Faq";
import OHADACountries from "../components/OHADACountries";


const  CinefEc = () => {
  return (
    <>

      <Header />


      <div className="about-banner d-flex align-items-center">
        <div className="container text-white text-start">
          <h1 className="fw-bold display-4">À Propos de Nous</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li className="breadcrumb-item active text-white" aria-current="page">
                À Propos
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <AboutSection />

      <WhoWeAre />
      <ExpertiseSection />
      <BenefitsSection />
      <OHADACountries />
      <FAQ />

      <Footer />


      <style>{`
       
        .about-banner {
          position: relative;
          background: linear-gradient(to right, rgba(255, 0, 0, 0.7), rgba(0, 150, 0, 0.7)), 
                      url("../assets/images/image14.png");
          background-size: cover;
          background-position: center;
          height: 400px;
          display: flex;
          align-items: center;
          color: white;
        }

        .about-banner .container {
          max-width: 600px;
        }

        .experience-box {
          position: absolute;
          bottom: -30px;
          left: 30px;
          background-color: #e63946;
          color: white;
          padding: 15px;
          border-radius: 10px;
          text-align: center;
        }

        .experience-box h3 {
          font-size: 48px;
          font-weight: 700;
          margin: 0;
        }

        .experience-box p {
          margin: 0;
          font-size: 18px;
        }

        .breadcrumb {
          background: transparent;
          font-size: 18px;
          padding: 0;
        }

        .breadcrumb-item a {
          color: white;
          font-weight: 500;
        }

        .breadcrumb-item.active {
          font-weight: bold;
        }
      `}</style>
    </>
  );
};

export default CinefEc;
